var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingOrbit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 148,
    viewBox: "0 0 375 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5282_61703)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.851,
    cy: 74.2471,
    rx: 212.5,
    ry: 37.5,
    transform: "rotate(-17.249 186.851 74.2471)",
    stroke: "#383838"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 74.5,
    r: 4.5,
    fill: "#00C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5 74L267.37 79.5709L273.339 77.6612L271.429 83.6299L277 86.5L271.429 89.3701L273.339 95.3388L267.37 93.4291L264.5 99L261.63 93.4291L255.661 95.3388L257.571 89.3701L252 86.5L257.571 83.6299L255.661 77.6612L261.63 79.5709L264.5 74Z",
    fill: "#00C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5282_61703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 410,
    height: 148,
    fill: "white",
    transform: "translate(-18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingOrbit);
export default __webpack_public_path__ + "static/media/loading_orbit.6b79b1e86b550bf27a5114836672fde2.svg";
export { ForwardRef as ReactComponent };